import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/issue_helper',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页'
    },
    beforeEnter: (to, from, next) => {
        if (!localStorage.username) {
            //console.log(from.name)
            // axios.get('/login/')
            // .then(function(response){
            //     var info_dict = JSON.parse(response.data)
            //     // localStorage['username'] = info_dict['username']
            // })
            // .catch(function(error){
            //     alert(error)
            // })
        }
        next()
    }
  },
  {
    path: '/issue_create',
    name: 'IssueCreate',
    component: () => import('../views/IssueCreate.vue'),
    meta: {
      title: 'BUG/问题填写'
    },
  },
  {
    path: '/issue_list',
    name: 'IssueList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/IssueList.vue'),
    meta: {
      title: 'BUG/问题列表'
    },
  },
  {
    path: '/issue_details',
    name: 'IssueDetails',
    component: () => import('../views/IssueDetails.vue'),
    meta: {
      title: 'BUG/问题预览'
    },
  },
  {
    path: '/issue_update',
    name: 'IssueUpdate',
    component: () => import('../views/IssueCreate.vue'),
    meta: {
      title: 'BUG/问题修改'
    },
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('../views/About.vue'),
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局前置路由守卫
// 未登录的情况下访问任何页面都路由到首页
router.beforeEach((to, from, next) => {
    // if (to.name != 'Home' && !localStorage.username){
    //     next({ name: 'Home' })
    // }
    // else {
    //     next()
    // }
    // localStorage['username'] = 'baoxin02'
    // localStorage['email'] = 'baoxin02@corp.netease.com'
    next()
  })

export default router
